'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_java$002eutil$002e$002dCollections$0024$0024anon$002415 from "./java.util.-Collections$$anon$15.js";
import * as $j_java$002eutil$002e$002dCollections$0024$002dImmutable$002dList from "./java.util.-Collections$-Immutable-List.js";
var $p;
/** @constructor */
function $c_ju_Collections$() {
}
export { $c_ju_Collections$ as $c_ju_Collections$ };
$p = $c_ju_Collections$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_ju_Collections$;
/** @constructor */
function $h_ju_Collections$() {
}
export { $h_ju_Collections$ as $h_ju_Collections$ };
$h_ju_Collections$.prototype = $p;
$p.XE = (function(o) {
  return new $j_java$002eutil$002e$002dCollections$0024$002dImmutable$002dList.$c_ju_Collections$ImmutableList(new $j_java$002eutil$002e$002dCollections$0024$0024anon$002415.$c_ju_Collections$$anon$15(o));
});
var $d_ju_Collections$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_ju_Collections$, "java.util.Collections$", ({
  mT: 1
}));
export { $d_ju_Collections$ as $d_ju_Collections$ };
var $n_ju_Collections$;
function $m_ju_Collections$() {
  if ((!$n_ju_Collections$)) {
    $n_ju_Collections$ = new $c_ju_Collections$();
  }
  return $n_ju_Collections$;
}
export { $m_ju_Collections$ as $m_ju_Collections$ };
